import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import SimpleBar from "simplebar-react";
//import logo
import logoDark from "assets/images/logo-dark.png";
import iconLogo from "assets/images/icon-logo.png";
import tradesmenLogoDark from "assets/images/tradesmens-white.png";
import logoLight from "assets/images/logo-light.png";
import tradesmenLogoLight from "assets/images/tradesmen-logo-dark.png";
import { jwtDecode } from "jwt-decode";

//Import Components
import VerticalLayout from "./VerticalLayouts/index";
import TwoColumnLayout from "./TwoColumnLayout";
import { Button, Container, Dropdown } from "react-bootstrap";
import HorizontalLayout from "./HorizontalLayout";
import { openLoganSupportTicket } from "features/productAssistant/events";
interface JwtPayload {
  userType: string;
  firstName?: string;
  lastName?: string;
  userName?: string;
}

const Sidebar = ({ layoutType }: any) => {
  const profileUser = useSelector((state: any) => state.UserProfile?.user);
  const profileData = useSelector((state: any) => state.UserProfile?.userData);
  const profileRecord = Array.isArray(profileUser) ? profileUser[0] : profileUser;
  const sidebarProfilePic =
    profileData?.ua_profile_pic || profileRecord?.ua_profile_pic;
  const [profilePicError, setProfilePicError] = useState(false);
  const token = localStorage.getItem("authUser");
  let decoded: any = "";
  if (token !== null) {
    decoded = jwtDecode<JwtPayload>(token);
  } else {
    console.error("Token is null");
  }

  const isRelibuildUser =
    decoded.userType === "homeowner" ||
    decoded.userType === "broker" ||
    decoded.userType === "real_estate_agent";
  const darkBrandLogo = isRelibuildUser ? logoDark : tradesmenLogoLight;
  const lightBrandLogo = isRelibuildUser ? logoLight : tradesmenLogoDark;
  const compactBrandLogo = isRelibuildUser ? darkBrandLogo : iconLogo;
  const accountLabel =
    decoded.userType === "admin"
      ? "Platform admin"
      : decoded.userType === "contractor" || decoded.userType === "subcontractor"
        ? "Contractor account"
        : decoded.userType === "homeowner"
          ? "Homeowner account"
          : "Property professional";
  const userLabel =
    [decoded.firstName, decoded.lastName].filter(Boolean).join(" ") ||
    decoded.userName ||
    (decoded.userType === "admin" ? "Admin console" : "Your account");

  const renderFullBrand = (brandLogo: string) =>
    isRelibuildUser ? (
      <img src={brandLogo} alt="RELiBUILD" className="brand-full-image" />
    ) : (
      <span className="modern-brand-lockup" aria-hidden="true">
        <img src={iconLogo} alt="" className="modern-brand-lockup__mark" />
        <span className="modern-brand-lockup__copy">
          <strong>tradesmen’s</strong>
          <small>collective</small>
        </span>
      </span>
    );

  useEffect(() => {
    setProfilePicError(false);
  }, [sidebarProfilePic]);

  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover"
    ) {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );
    } else if (
      document.documentElement.getAttribute("data-sidebar-size") ===
      "sm-hover-active"
    ) {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    }
  };

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu modern-sidebar">
        <div className="navbar-brand-box modern-brand-box">
          <Link to={process.env.PUBLIC_URL + "/"} className="logo logo-dark modern-brand" aria-label="Go to dashboard">
            <span className="logo-sm">
              <img src={compactBrandLogo} alt="" className={`brand-mark-image ${isRelibuildUser ? "relibuild-mark" : "tradesmen-mark"}`} />
            </span>
            <span className="logo-lg">
              {renderFullBrand(darkBrandLogo)}
            </span>
          </Link>

          <Link to={process.env.PUBLIC_URL + "/"} className="logo logo-light modern-brand" aria-label="Go to dashboard">
            <span className="logo-sm">
              <img src={compactBrandLogo} alt="" className={`brand-mark-image ${isRelibuildUser ? "relibuild-mark" : "tradesmen-mark"}`} />
            </span>
            <span className="logo-lg">
              {renderFullBrand(lightBrandLogo)}
            </span>
          </Link>
          <Button
            variant="link"
            size="sm"
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn p-0 fs-3xl header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </Button>
        </div>
        {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout layoutType={layoutType} />
              </ul>
            </Container>
          </div>
        ) : layoutType === "twocolumn" ? (
          <React.Fragment>
            <TwoColumnLayout layoutType={layoutType} />
            <div className="sidebar-background"></div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SimpleBar id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>
            <Dropdown drop="up" align="end" className="sidebar-account-dropdown">
              <Dropdown.Toggle
                as="button"
                type="button"
                className="sidebar-workspace-card"
                aria-label={`Open account menu for ${userLabel}`}
              >
                <span className="sidebar-workspace-card__avatar" aria-hidden="true">
                  {sidebarProfilePic && !profilePicError ? (
                    <img
                      src={sidebarProfilePic}
                      alt=""
                      onError={() => setProfilePicError(true)}
                    />
                  ) : (
                    userLabel.charAt(0).toUpperCase()
                  )}
                </span>
                <span className="sidebar-workspace-card__copy">
                  <strong>{userLabel}</strong>
                  <span>{accountLabel}</span>
                </span>
                <span className="sidebar-workspace-card__verified" title="Open account menu">
                  <i className="bi bi-chevron-expand" aria-hidden="true" />
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="sidebar-account-menu">
                <div className="sidebar-account-menu__header">
                  <strong>{userLabel}</strong>
                  <span>{accountLabel}</span>
                </div>
                <Dropdown.Item as={Link} to="/pages-profile-settings">
                  <i className="bi bi-person" aria-hidden="true" />
                  <span>Profile settings</span>
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="/apps-chat">
                  <i className="bi bi-chat-left-text" aria-hidden="true" />
                  <span>Messages</span>
                </Dropdown.Item>
                <Dropdown.Item as="button" type="button" onClick={openLoganSupportTicket}>
                  <i className="bi bi-life-preserver" aria-hidden="true" />
                  <span>Help & support</span>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item as={Link} to="/logout" className="sidebar-account-menu__logout">
                  <i className="bi bi-box-arrow-right" aria-hidden="true" />
                  <span>Log out</span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <div className="sidebar-background"></div>
          </React.Fragment>
        )}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
